<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th></th>
          <th>Factuurnummer</th>
          <th>Factuurdatum</th>
          <th>Betaaldatum</th>
          <th>Bedrag</th>
        </tr>
      </thead>
      <thead></thead>
      <tbody v-if="!loading">
        <tr v-for="(payment, index) in payments" :key="index">
          <td>
            <router-link :to="{name: 'subscription-payment', params:{ id:routeParams.id, subscription_id: routeParams.subscription_id, payment_id:payment.id}}">
              <i class="fa fa-eye"></i>
            </router-link>
          </td>
          <td> {{ payment.invoice_number }} </td>
          <td>
           {{ payment.invoice_date }}
          </td>
          <td > {{ payment.payment_date }} </td>
          <td>   {{ Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: 'EUR'
                }).format(payment.amount) }}
          </td>
        </tr>
        
      </tbody>
      <tr v-else>
          <td colspan="5" class="text-center">Aan het laden...</td>
        </tr>
    </table>

    <div
      class="modal fade"
      id="newsitemModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 1000px">
        <div class="modal-content committee-modal">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <h4 class="modal-title">Title</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <p ></p>
              </div>
              <div class="col-lg-12">
                <button data-dismiss="modal" class="btn-dark float-right mt-3">
                  Sluiten
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '../../../../router';
import mixins from '../../../mixins';

export default {
  name: "index",
  mixins: [mixins],
  components: {},
  computed: {
   
  },
  data() {
    return {
      payments:{},
      loading: false,
      routeParams: {}
    };
  },
  methods: {
    getPayments(){
      this.loading = true;
      var endpoint = this.$route.params.id+'/subscriptions/'+this.$route.params.subscription_id+'/payments';
      this.$store.dispatch('get', '/api/v1/profile/'+endpoint)
      .then((data)=>{
        this.payments = data.data.data;
        this.loading = false;
      })
      .catch((error)=>{
        console.log(error)
        this.loading = false;
      })
      
    }
  },
  created(){
    if(!(this.$route.params.id != this.$store.state.auth.user.id)){
      if(!(this.userHasPermissions(['Financieel']) && this.userHasRoles(['super-admin']))){
        router.go(-1)
      }
    }
    this.getPayments();
    this.routeParams = this.$route.params;
  }
};
</script>

<style scoped>
.small-size {
  font-size: 0.875rem !important;
}

.no-border {
  border-style: solid;
  border-width: 0px 0px 0px 0px;
}

.committee-modal {
  background: #4192d9;
  color: white;
}
.committee-modal button {
  background: black;
  color: white;
}
</style>
